import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { I18n } from '../../_ui-core_/base/package/services/package/i18n/i18n.de';
import { updateRobotsTag } from '../../_ui-core_/base/package/util/html-helper';
import App from '../../app';
import style from './login-required-page.css?inline';
import '../../_ui-core_/components/icons/ui-stop-icon';

const CName = 'login-required-page';

@customElement(CName)
export class LoginRequiredPage extends LitElement {
  static readonly styles = unsafeCSS(style);

  connectedCallback(): void {
    super.connectedCallback();
    updateRobotsTag('none');
  }

  render() {
    return html`
        <main class="main">
          <div class="content">
            <div class="icon">
              <ui-stop-icon></ui-stop-icon>
            </div>
            <h1 class="title">${window.$app.$t.get(I18n.base.loginRequiredTitle)}</h1>
            <div class="message">${window.$app.$t.get(I18n.base.loginRequiredMessage)}</div>
            <div class="buttons">
              <ui-btn variant="secondary" .isBlock=${true} @click=${this._handleLoginClick}>${window.$app.$t.get(I18n.base.login)}</ui-btn>
              <ui-btn variant="secondary-outlined" .isBlock=${true} @click=${this._handleHomeClick}>${window.$app.$t.get(I18n.base.backToHome)}</ui-btn>
            </div>
          </div>
        </main>
    `;
  }

  private _handleLoginClick() {
    App.instance.product.gotoLogin(CName);
  }

  private _handleHomeClick() {
    App.instance.router.navigateToHome();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: LoginRequiredPage;
  }
}
